/* eslint-disable */
import axios from "axios";
import OktaAuthRef from "../auth/okta";

class HttpConnector {
  static async makeRequest({
    methodType,
    url,
    payload = {},
    additionalHeaders = {},
    authenticated = true
  }) {
    const headers = {
      ...additionalHeaders
    };
    if (authenticated) {
      const idToken = OktaAuthRef.getIdToken();
      // eslint-disable-next-line dot-notation
      headers["Authorization"] = `Bearer ${idToken}`;
    }
    console.log('methodType :>> ', methodType);
    console.log('headers :>> ', headers);
    if (methodType.toLowerCase() === "get" || methodType.toLowerCase() === "delete") {
      return axios[methodType](url, { headers, crossdomain: true });
    } else {
      return axios[methodType](url, payload, { headers, crossdomain: true });
    }
  }
}

export default HttpConnector;
